const data = {
engLang : [
    {
        "id" : 0,
        "subHeading" : "Ladkiyon aur Aurton ka Haal Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ke Aane Se Pehle :",
        "content" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ke aane se pehle duniya me aurton aur ladkiyon ke saath jo sulook hota tha, wo nihayat zaleel aur insaniyat ke usoolo'n ke khilaf tha. Unhe na sirf apne huqooq se mehroom rakha jata tha, balki unhe ek bojh samjha jata tha. Arab aur duniya ke mukhtalif hisson me aurton ki haalat nihayat afsosnaak thi, aur unka maqaam mard ke muqable me bohot neecha tha.",   
        "reference" : "",
        "subHeading2" : "Arab Me Aurto'n aur Ladkiyon ki Halat",
        "content2" : "Jahiliyat ke daur me Arab me ladki ki paidaish ko sharm ka sabab samjha jata tha. Log apni betiyon ko zinda dafan kar diya kart the, kyunke unka manna tha ke beti sirf beizzati ka sabab banegi. Aurton ke paas kisi qisam ke huqooq nahi the, aur na hi koi izzat. Arab ke ilawa, duniya ke doosre hisson me bhi aurton ki haalat mukhtalif nahi thi. Hindustan me aurton ko mard ki milkiyat samjha jata tha. 'Sati' ka rivaaj tha jisme mard ke inteqal ke baad uski biwi ko bhi uske saath zinda jala diya jata tha. Taleem aur aazadi ka koi tasavvur nahi tha.",
        "reference2" : "",
        "subHeading3" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> Ki Taleemat Aur Aurton Ke Huqooq",
        "content3" : `Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ke aane ke baad aurton ke liye ek naye dor ka aghaaz hua. Islam ne aurat ko izzat, maqam aur haqooq diye jo us se pehle kabhi nahi mile. Ladki ki paidaish ko rehmat qarar diya gaya, aur beti ki parwarish ko sawab aur Jannat ka zariya banaya gaya.
        Quran-e-Pak ne aurton ke maqam ko buland kiya aur insani barabari ka tasavvur diya. Shaadi aur talaq ke nizam ko insaf par mabni banaya gaya. Aurton ko maal me hissa diya gaya.
        Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne apne amal aur taleemat ke zariye maashray me aurton ke maqam ko izzat di. Maa, behan, biwi aur beti ke roop me aurton ke huqooq aur izzat ko tasleem kiya gaya.`,
        "reference3" : "",
    },
    {
        "id" : 1    ,
        "subHeading" : "1. Zamana-e-Jahiliyat me Beti ka haal",
        "content" : "Zamana-e-Jahiliyat me betiyon ko sharam aur zillat ka sabab samjha jata tha. Quran Majeed me is rawaiye ki sakht mazammat ki gayi hai:",
        "reference" : "",
        "subHeading2" : "Quran :",
        "content2" : "Aur jab in me kisi ko beti hone ki khushkhabri di jati hai to din bhar us ka muh siyah (kala) rahta hai aur wo gussa khata hai, logo se (sharm ke mare) chhup-ta phirta hai is basharat ki burai ke sabab, kya use zillat ke sath rakhega  ya use mitti me daba dega, Are bahut hi bura hukm lagate hain.",
        "reference2" : "(Surah An-Nahl: 58-59)",
        "subHeading3" : "",
        "content3" : "Islam ne beti ko zinda dafn karne ki is riwayat ko poori tarah khatm kiya.",
        "reference3" : "",
    },
    {
        "id" : 2,
        "subHeading" : "2. Beti ki Paidaish Ko Barkat Aur Rahmat Qarar Dena",
        "content" : "Islam ne betiyon ki paidaish ko nafrat ki jagah ek barkat aur rahmat qarar diya. Jahalat ke daur me log betiyon ko zinda dafna dete the, lekin Islam ne is jahalat ko khatam kiya. Islam ne beti ki paidaish ko na sirf barkat samjha, balke jannat ka zariya banaya.",
        "reference" : "",
        "subHeading2" : "Hadees :",
        "content2" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Jisne 2 ladkiyo'n ki kifalat ki to mai aur wo jannat me is tarah dakhil honge. AAP <span class='fs-30'>ﷺ </span> ne kaifiyat batane ke liye apni dono ungliyo'n (shahadat aur darmiyani) se ishara kiya.",
        "reference2" : "(Sunan Tirmizi, Hadees No. 1914)",
        "subHeading3" : "Quran:",
        "content3" : "Allah hi ke liye hai Aasmano aur zameen ki saltanat, paida karta hai jo chhahe, jise chhahe Betiya'n ata farmaye aur jise chhahe bete de",
        "reference3" : "(Surah Ash-Shura: 49)",
        "subHeading4" : "Allah ki Raza par Razi Rehna",
        "content4" : "Allah ki marzi aur hikmat ke mutabiq hi sab kuch hota hai. Ek Momin ke liye yeh zaroori hai ki woh samjhe ke jo Allah deta hai, usmein uski rehmat aur behtareen plan chhupa hota hai. Allah har cheez ka malik hai. Beti ho ya beta, dono ka milna Allah ki taraf se ek inayat hai, aur yeh insan ke bas me nahi hai. Islam ne betiyon ko izzat aur maqam diya hai. Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne betiyon ki parwarish karne aur unke saath achha sulook karne ko jannat ka zariya qarar diya hai. Betiyan kisi tarah se bhi kam nahi hain, balki ek barakat aur rahmat hain. Sirf beto'n ki tamanna karna aur betiyon ko kam samajhna Islam ki taleem ke khilaf hai. Jo kuch Allah deta hai, hame us par razi rehna aur shukr ada karna chahiye. Islam ka paigham hai ki betiyan aur bete dono barabar hain. Dono Allah ki nemat hain aur dono ki parwarish mohabbat aur tawajjo ke saath honi chahiye. Hame Apni chahat aur duaon ko Allah ki raza ke mutabiq rakhna chahiye. Agar Allah betiyan deta hai to yeh uski rehmat hai, aur humein un (betiyon) ki tarbiyat mohabbat aur deen ke mutabiq karni chahiye. Allah ke har faisle ko qubool karna aur uska shukar ada karna ek sacha momin banata hai.",
        "reference4" : "",
    },
    {
        "id" : 3,
        "subHeading" : "3. Betiyon Ke Saath Mohabbat Aur Shafqat Ka Sulook",
        "content" : "Islam ne betiyon ke sath mohabbat ka sulook karne ka hukm diya.",
        "reference" : "",
        "subHeading2" : "",
        "content2" : "",
        "reference2" : "",
        "subHeading3" : "Hadees :",
        "content3" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Jis shakhs ke yahan beti ki paidaish ho, wo ise zinda dargor kare aur na hi use haqeer samjhe aur na hi ladke ko us per tarjeeh de to Allah Ta'ala use jannat me dakhila ata farmayega.",
        "reference3" : "(Musnad Ahmad, Hadees No. 1957)",
    },
    {
        "id" : 4,
        "subHeading" : "4. Betiyon Ki Tarbiyat Ka Ehem Kirdar",
        "content" : "Islam me betiyon ki taleem aur tarbiyat ko jannat ka zariya qarar diya gaya hai.",
        "reference" : "",
        "subHeading2" : "Hadees :",
        "content2" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Jis shakhs ne 3 betiyo'n ki parwarish ki, inhe adab sikhaya, unki shadi ki aur unke sath ahsan ka mamla karta raha, to uske liye Jannat hai.",
        "reference2" : "(Sunan Abu Dawood, Hadees No. 5147)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "",
    },
    {
        "id" : 5,
        "subHeading" : "5. Betiyan, Jannat me le jane ka zariya",
        "content" : "",
        "reference" : "",
        "subHeading2" : "Hadees :",
        "content2" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Jis shakhs ki 3 betiya'n ho aur wo unki mushkilat, takaleef aur khushiyo'n per sabr shukr kare, Allah un bacchiyo'n per uski meharbani ke sabab us shakhs ko jannat me apne fazl se dakhila ata farmayega, kisi ne poocha, Ya RasoolAllah <span class='fs-30'>ﷺ </span> Agar 2 betiya'n ho to? Aap <span class='fs-30'>ﷺ </span> ne farmaya, tab bhi yahi hukm hai,kisi ne poocha, Ya RasoolAllah <span class='fs-30'>ﷺ </span> Agar 1 beti ho to? Aap <span class='fs-30'>ﷺ </span> ne farmaya, tab bhi yahi hukm hai. ",
        "reference2" : "(Musnad Ahmad : 8406)",
        "subHeading3" : "",
        "content3" : "Islam me betiyon ko rehmat qarar diya gaya hai. Unki paidaish par khushi manana, unki taleem o tarbiyat karna, unke huqooq ka khayal rakhna, unse mohabbat karna, aur unke saath husn-e-suluk karna ek Musalman ki buniyadi zimmedari hai. Waliden ke liye betiyon ki achhi tarbiyat aur unki zimmedariyon ko khush asloobi se nibhana Jannat ke husool ka zariya hai.",
        "reference3" : "",
    },
    {
        "id" : 6,
        "subHeading" : "6. Betiyan, Jahannam ki aag se rukawat",
        "content" : "",
        "reference" : "",
        "subHeading2" : "Hadees :",
        "content2" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Jis shakhs ki 3 ya 2 betiya'n ya bahne(sisters) ho, wo unke maamle me Allah se dare aur uske sath accha sulook kare yahan tak ki unki shaadi ho jaye ya faut ho jaye'n to wo uske liye jahannam ki aag se rukawat ban jayengi.",
        "reference2" : "(Musnad Ahmad : 24508)",
        "subHeading3" : "Hadees :",
        "content3" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Jis ke paas teen ladkiyan ho, aur wo unke hone par sabr kare, aur jo kuch muyassar ho usme se unhe khilaye, pilaye aur pahnaye, to wo us shakhs ke liye qayamat ke din Jahannam se rukawat ban jayengi.",
        "reference3" : "(Sunan Ibn Majah, Hadith 3669)",
    },
    {
        "id" : 7,
        "subHeading" : "7. Betiyon Ko Takleef Na Dene Ki Naseehat",
        "content" : "Islam ne betiyon ko takleef pohchane se sakht mana kiya hai.",
        "reference" : "",
        "subHeading2" : "Hadees :",
        "content2" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Aurto ke sath accha sulook karo.",
        "reference2" : "(Betiyon ko bhi aurton ke zumre me shamil kiya gaya hai, isliye unke saath shafqat aur ehtram ka rawayya apnana zaroori hai.)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "(Bukhari Shareef : 3331)",
    },
    {
        "id" : 8,
        "subHeading" : "8. Betiyon Ke Liye Maali Huqooq",
        "content" : "",
        "reference" : "",
        "subHeading2" : "Wirasat Me Hissa :",
        "content2" : "Betiyon ko wirasat me unka haq diya jaye.",
        "reference2" : "",
        "subHeading3" : "Quran :",
        "content3" : "Ladki ka hissa ladke ke hissa ka aadha hai.",
        "reference3" : "(Surah An-Nisa: 11)",
    },
    {
        "id" : 9,
        "subHeading" : "9. Taleem Aur Tadrees",
        "content" : "Islam me taleem hasil karna farz aur zarurat hai. Quran aur hadees dono me taleem ki ahmiyat par zor diya gaya hai.",
        "reference" : "",
        "subHeading2" : "Hadees :",
        "content2" : "<span class='urduFont fs-30'>طَلَبُ الْعِلْمِ فَرِيضَةٌ عَلَى كُلِّ مُسْلِمٍ</span>",
        "reference2" : "",
        "subHeading3" : "",
        "content3" : "Ilm hasil karna har Musalman par farz hai.",
        "reference3" : "(Sunan Ibn Majah, Hadith 224)",
    },
    {
        "id" : 10,
        "subHeading" : "10. Accha kirdaar apnana",
        "content" : "",
        "reference" : "",
        "subHeading2" : "Hadees :",
        "content2" : "Huzur Nabi-E-Kareem <span class='fs-30'>ﷺ </span> ne irshad farmaya: </br> Tum me se behtar wo hai jo apne ghar walo ke liye behtar ho.",
        "reference2" : "(Sunan Tirmizi : 3895)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "",
    },
    {
        "id" : 11,
        "subHeading" : "11. Walidain Ke Saath Achha Sulook",
        "content" : "Islam me apne walidain ke sath achha sulook karna lazmi hai.",
        "reference" : "",
        "subHeading2" : "Quran :",
        "content2" : "Aur humne insaan ko uske Maa-Baap ke bare me takeed farmayi. ",
        "reference2" : "ki unka farmabardaar rahe aur unke sath Nek sulook kare.",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "(Surah Luqman: 14)",
    },
    {
        "id" : 12,
        "subHeading" : "12. Betiyon Ko Zillat Se Bachana",
        "content" : "Islam me betiyon ko zillat aur sharamindagi se bacha kar izzat dena lazim hai.",
        "reference" : "",
        "subHeading2" : "Quran :",
        "content2" : "<span class='urduFont fs-30'>وَإِذَا ٱلْمَوْءُۥدَةُ سُئِلَتْ ٨  بِأَىِّ ذَنۢبٍۢ قُتِلَتْ ٩</span>",
        "reference2" : "Tarjama : Aur Jab zinda dabai hui se poocha jaye, Kis khata par maari gayi.",
        "subHeading3" : "",
        "content3" : "Yani us ladki se jo zinda dafn ki gayi ho jaisa ki Arab ka dastoor tha ki Zamana-E-Jahiliyat me ladkiyou'n ko zinda dafn kar dete the.        ",
        "reference3" : "",
    },
    {
        "id" : 13,
        "subHeading" : "",
        "content" : `Kya Fazilate Aayi Hain Quran aur Hadees-E-Paak Me Betiyo Ke Talluq Se.
                        Magar Afsos! Aaj Ke Zamane Me Log Ladki Ki Paidaish Par Gamzada Ho Jate Hai.
                        Ladkiyo Ko Ladko Jaisa Darja, Izzat Aur Haq Nahi Dete.
                        Log Ladko Ko Nasl Ka Chirag Jante Hai Magar Betiya To Na Sirf Duniya Me Unki Khidmat Karti Hain Waldain Ke Wisal Ke Baad Bhi Unke Jannat Ka Sabab Banti Hai. Jab Wo BETI Hoti Hai, Apne Walid Ke Liye Jannat Ke Darwaje Khol Deti Hai
                        Jab Wo BIWI Banti Hai, Shohar Ka Aadha(Half) Deen Muqammal Kar Deti Hai
                        Jab Wo Maa Banti Hai, Jannat Uske Qadmo Me Hoti Hai </br>
                        tabhi to kisi shayar ne kya khoob kaha hai ki : </br>
                        "Betiya Sabke Muqaddar Me Kaha Hoti Hain </br>
                        Ghar Khuda Ko Jo Pasand Aaye Waha Hoti Hain."`,
        "reference" : "",
        "subHeading2" : "",
        "content2" : "",
        "reference2" : "",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "",
    },
  ],
urduLang : [
    {
        "id" : 0,
        "subHeading" : " لڑکیوں اور عورتوں کا حال حضور نبی کریم <span class='fs-30'>ﷺ </span> کے آنے سے پہلے  ",
        "content" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> کے آنے سے پہلے دنیا میں عورتوں اور لڑکیوں کے ساتھ جو سلوک ہوتا تھا، وہ نہایت ذلیل اور انسانیت کے اصولوں کے خلاف تھا۔ انہیں نہ صرف اپنے حقوق سے محروم رکھا جاتا تھا بلکہ انہیں ایک بوجھ سمجھا جاتا تھا۔ عرب اور دنیا کے مختلف حصوں میں عورتوں کی حالت نہایت افسوسناک تھی، اور ان کا مقام مرد کے مقابلے میں بہت نیچا تھا۔",   
        "reference" : "",
        "subHeading2" :  " عرب میں عورتوں اور لڑکیوں کی حالت :",
        "content2" : "جہالت کے دور میں عرب میں لڑکی کی پیدائش کو شرم کا سبب سمجھا جاتا تھا۔ لوگ اپنی بیٹیوں کو زندہ دفن کر دیا کرتے تھے کیونکہ ان کا ماننا تھا کہ بیٹی صرف بے عزتی کا سبب بنے گی۔ عورتوں کے پاس کسی قسم کے حقوق نہیں تھے، اور نہ ہی کوئی عزت۔ عرب کے علاوہ دنیا کے دوسرے حصوں میں بھی عورتوں کی حالت مختلف نہیں تھی۔ ہندوستان میں عورتوں کو مرد کی ملکیت سمجھا جاتا تھا۔ 'ستی' کا رواج تھا جس میں مرد کے انتقال کے بعد اس کی بیوی کو بھی اس کے ساتھ زندہ جلا دیا جاتا تھا۔ تعلیم اور آزادی کا کوئی تصور نہیں تھا۔",
        "reference2" : "",
        "subHeading3" :  " حضور نبی کریم <span class='fs-30'>ﷺ </span> کی تعلیمات اور عورتوں کے حقوق",
        "content3" : `حضور نبی کریم <span class='fs-30'>ﷺ </span> کے آنے کے بعد عورتوں کے لیے ایک نئے دور کا آغاز ہوا۔ اسلام نے عورت کو عزت، مقام اور حقوق دیے جو اس سے پہلے کبھی نہیں ملے۔ لڑکی کی پیدائش کو رحمت قرار دیا گیا، اور بیٹی کی پرورش کو ثواب اور جنت کا ذریعہ بنایا گیا۔
        قرآن پاک نے عورتوں کے مقام کو بلند کیا اور انسانی برابری کا تصور دیا۔ شادی اور طلاق کے نظام کو انصاف پر مبنی بنایا گیا۔ عورتوں کو مال میں حصہ دیا گیا اور انہیں خود اپنی زندگی کے فیصلے لینے کا حق عطا کیا گیا۔
        حضور نبی کریم <span class='fs-30'>ﷺ </span> نے اپنے عمل اور تعلیمات کے ذریعے معاشرے میں عورتوں کے مقام کو عزت دی۔ ماں، بہن، بیوی اور بیٹی کے روپ میں عورتوں کے حقوق اور عزت کو تسلیم کیا گیا۔`,
        "reference3" : "",
    },
    {
        "id" : 1,
        "subHeading" : "۱ ۔ زمانۂ جاہلیت میں بیٹی کا حال : ",
        "content" : "زمانۂ جاہلیت میں بیٹیوں کو شرم اور ذلت کا سبب سمجھا جاتا تھا۔ قرآن مجید میں اس رویے کی سخت مذمت کی گئی ہے:",
        "reference" : "",
        "subHeading2" : "قرآن :",
        "content2" : "اور جب ان میں کسی کو بیٹی ہونے کی خوشخبری دی جاتی ہے تو دن بھر اس کا چہرہ سیاہ (کالا) رہتا ہے اور وہ غصہ کھاتا ہے، لوگوں سے (شرم کے مارے) چھپتا پھرتا ہے اس خوشخبری کی برائی کے سبب، کیا اسے ذلت کے ساتھ رکھے گا یا اسے مٹی میں دبا دے گا؟ ارے بہت ہی برا حکم لگاتے ہیں۔",
        "reference2" : "(سورہ النحل: ۵۸-۵۹)",
        "subHeading3" : "",
        "content3" : "اسلام نے بیٹی کو زندہ دفن کرنے کی اس روایت کو پوری طرح ختم کیا۔",
        "reference3" : "",
    },
    {
        "id" : 2,
        "subHeading" : "۲۔ بیٹی کی پیدائش کو برکت اور رحمت قرار دینا:",
        "content" : "اسلام نے بیٹیوں کی پیدائش کو نفرت کی جگہ ایک برکت اور رحمت قرار دیا۔ جہالت کے دور میں لوگ بیٹیوں کو زندہ دفنا دیتے تھے، لیکن اسلام نے اس جہالت کو ختم کیا۔ اسلام نے بیٹی کی پیدائش کو نہ صرف برکت سمجھا بلکہ جنت کا ذریعہ بنایا۔",
        "reference" : "",
        "subHeading2" : "حدیث : ",
        "content2" : "جس نے 2 لڑکیوں کی کفالت کی تو میں اور وہ جنت میں اس طرح داخل ہوں گے۔ آپ ﷺ نے کیفیت بتانے کے لیے اپنی دونوں انگلیوں (شہادت اور درمیانی) سے اشارہ کیا۔",
        "reference2" : "(سنن ترمذی، حدیث نمبر ۱۹۱۴)",
        "subHeading3" : "قرآن :  ",
        "content3" : "اللہ ہی کے لیے ہے آسمانوں اور زمین کی سلطنت، پیدا کرتا ہے جو چاہے، جسے چاہے بیٹیاں عطا فرمائے اور جسے چاہے بیٹے دے۔",
        "reference3" : "(سورہ الشوریٰ: ۴۹)",
        "subHeading4" : "اللہ کی رضا پر راضی رہنا :   ",
        "content4" : ` اللہ کی مرضی اور حکمت کے مطابق ہی سب کچھ ہوتا ہے۔ ایک مومن کے لیے یہ ضروری ہے کہ وہ سمجھے کہ جو کچھ اللہ دیتا ہے، اس میں اس کی رحمت اور بہترین پلان چھپا ہوتا ہے۔ اللہ ہر چیز کا مالک ہے۔ بیٹی ہو یا بیٹا، دونوں کا ملنا اللہ کی طرف سے ایک عنایت ہے، اور یہ انسان کے بس میں نہیں ہے۔ اسلام نے بیٹیوں کو عزت اور مقام دیا ہے۔ حضور نبی کریم ﷺ نے بیٹیوں کی پرورش کرنے اور ان کے ساتھ اچھا سلوک کرنے کو جنت کا ذریعہ قرار دیا ہے۔
        بیٹیاں کسی طرح سے بھی کم نہیں ہیں، بلکہ ایک برکت اور رحمت ہیں۔ صرف بیٹوں کی خواہش کرنا اور بیٹیوں کو کم سمجھنا اسلام کی تعلیمات کے خلاف ہے۔ جو کچھ اللہ دیتا ہے، ہمیں اس پر راضی رہنا اور شکر ادا کرنا چاہیے۔ اسلام کا پیغام ہے کہ بیٹیاں اور بیٹے دونوں برابر ہیں۔ دونوں اللہ کی نعمت ہیں اور دونوں کی پرورش محبت اور توجہ کے ساتھ ہونی چاہیے۔
        ہمیں اپنی خواہشات اور دعاؤں کو اللہ کی رضا کے مطابق رکھنا چاہیے۔ اگر اللہ بیٹیاں دیتا ہے تو یہ اس کی رحمت ہے، اور ہمیں ان (بیٹیوں) کی تربیت محبت اور دین کے مطابق کرنی چاہیے۔ اللہ کے ہر فیصلے کو قبول کرنا اور اس کا شکر ادا کرنا ہی ایک سچے مومن کی پہچان ہے۔
        `,
        "reference4" : "",
    },
    {
        "id" : 3,
        "subHeading" : "۳۔ بیٹیوں کے ساتھ محبت اور شفقت کا سلوک",
        "content" : "اسلام نے بیٹیوں کے ساتھ محبت اور شفقت کا سلوک کرنے کا حکم دیا ہے۔",
        "reference" : "",
        "subHeading2" : "",
        "content2" : "",
        "reference2" : "",
        "subHeading3" : "حدیث :",
        "content3" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> نے ارشاد فرمایا  </br> جس شخص کے یہاں بیٹی کی پیدائش ہو، وہ اسے زندہ درگور نہ کرے، نہ ہی اسے حقیر سمجھے اور نہ ہی لڑکے کو اس پر ترجیح دے تو اللہ تعالیٰ اسے جنت میں داخلہ عطا فرمائے گا۔",
        "reference3" : "(مسند احمد، حدیث نمبر: ۱۹۵۷)"
    },
    {
        "id" : 4,
        "subHeading" : "۴۔ بیٹیوں کی تربیت کا اہم کردار",
        "content" : "اسلام میں بیٹیوں کی تعلیم اور تربیت کو جنت کا ذریعہ قرار دیا گیا ہے۔",
        "reference" : "",
        "subHeading2" : "حدیث :",
        "content2" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> نے ارشاد فرمایا  </br> جس شخص نے ۳ بیٹیوں کی پرورش کی، انہیں ادب سکھایا، ان کی شادی کی اور ان کے ساتھ احسان کا معاملہ کرتا رہا، تو اس کے لیے جنت ہے۔",
        "reference2" : "(سنن ابو داؤد، حدیث نمبر: ۵۱۴۷)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : ""
    },
    {
        "id" : 5,
        "subHeading" : "۵۔ بیٹیاں، جنت میں لے جانے کا ذریعہ",
        "content" : "",
        "reference" : "",
        "subHeading2" : "حدیث :",
        "content2" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> نے ارشاد فرمایا </br> جس شخص کی ۳ بیٹیاں ہوں اور وہ ان کی مشکلات، تکالیف اور خوشیوں پر صبر و شکر کرے، اللہ ان بچیوں پر اس کی مہربانی کے سبب اس شخص کو جنت میں اپنے فضل سے داخلہ عطا فرمائے گا۔ کسی نے پوچھا، یا رسول اللہ <span class='fs-30'>ﷺ </span> اگر ۲ بیٹیاں ہوں تو؟ آپ <span class='fs-30'>ﷺ </span> نے فرمایا، تب بھی یہی حکم ہے۔ کسی نے پوچھا، یا رسول اللہ <span class='fs-30'>ﷺ </span> اگر ۱ بیٹی ہو تو؟ آپ <span class='fs-30'>ﷺ </span> نے فرمایا، تب بھی یہی حکم ہے۔",
        "reference2" : "(مسند احمد: ۸۴۰۶)",
        "subHeading3" : "",
        "content3" : "اسلام میں بیٹیوں کو رحمت قرار دیا گیا ہے۔ ان کی پیدائش پر خوشی منانا، ان کی تعلیم و تربیت کرنا، ان کے حقوق کا خیال رکھنا، ان سے محبت کرنا، اور ان کے ساتھ حسنِ سلوک کرنا ایک مسلمان کی بنیادی ذمہ داری ہے۔ والدین کے لیے بیٹیوں کی اچھی تربیت اور ان کی ذمہ داریوں کو خوش اسلوبی سے نبھانا جنت کے حصول کا ذریعہ ہے۔",
        "reference3" : ""
    },
    {
        "id" : 6,
        "subHeading" : "۶۔ بیٹیاں، جہنم کی آگ سے رکاوٹ",
        "content" : "",
        "reference" : "",
        "subHeading2" : "حدیث :",
        "content2" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> نے ارشاد فرمایا  </br> جس شخص کی ۳ یا ۲ بیٹیاں یا بہنیں ہوں، وہ ان کے معاملے میں اللہ سے ڈرے اور ان کے ساتھ اچھا سلوک کرے یہاں تک کہ ان کی شادی ہو جائے یا وہ وفات پا جائیں تو وہ اس کے لیے جہنم کی آگ سے رکاوٹ بن جائیں گی۔",
        "reference2" : "(مسند احمد: ۲۴۵۰۸)",
        "subHeading3" : "حدیث :",
        "content3" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> نے ارشاد فرمایا </br> جس کے پاس تین لڑکیاں ہوں، اور وہ ان کے ہونے پر صبر کرے، اور جو کچھ میسر ہو اس میں سے انہیں کھلائے، پلائے اور پہنائے، تو وہ اس شخص کے لیے قیامت کے دن جہنم سے رکاوٹ بن جائیں گی۔",
        "reference3" : "(سنن ابن ماجہ، حدیث ۳۶۶۹)"
    },
    {
        "id" : 7,
        "subHeading" : "۷۔ بیٹیوں کو تکلیف نہ دینے کی نصیحت",
        "content" : "اسلام نے بیٹیوں کو تکلیف پہنچانے سے سخت منع کیا ہے۔",
        "reference" : "",
        "subHeading2" : "حدیث :",
        "content2" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> نے ارشاد فرمایا: </br> عورتوں کے ساتھ اچھا سلوک کرو۔",
        "reference2" : "(بیٹیوں کو بھی عورتوں کے زمرے میں شامل کیا گیا ہے، اس لیے ان کے ساتھ شفقت اور احترام کا رویہ اپنانا ضروری ہے۔)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "(بخاری شریف: ۳۳۳۱)"
    },
    {
        "id" : 8,
        "subHeading" : "۸۔ بیٹیوں کے لیے مالی حقوق",
        "content" : "",
        "reference" : "",
        "subHeading2" : "وراثت میں حصہ:",
        "content2" : "بیٹیوں کو وراثت میں ان کا حق دیا جائے۔",
        "reference2" : "",
        "subHeading3" : "قرآن:",
        "content3" : "لڑکی کا حصہ لڑکے کے حصے کا آدھا ہے۔",
        "reference3" : "(سورۃ النساء: ۱۱)"
    },
    {
        "id" : 9,
        "subHeading" : "۹۔ تعلیم اور تدریس",
        "content" : "اسلام میں تعلیم حاصل کرنا فرض اور ضرورت ہے۔ قرآن اور حدیث دونوں میں تعلیم کی اہمیت پر زور دیا گیا ہے۔",
        "reference" : "",
        "subHeading2" : "حدیث :",
        "content2" : "<span class='urduFont fs-30'>طَلَبُ الْعِلْمِ فَرِيضَةٌ عَلَى كُلِّ مُسْلِمٍ</span>",
        "reference2" : "",
        "subHeading3" : "",
        "content3" : "علم حاصل کرنا ہر مسلمان پر فرض ہے۔",
        "reference3" : "(سنن ابن ماجہ، حدیث ۲۲۴)"
    },
    {
        "id" : 10,
        "subHeading" : "۱۰۔ اچھا کردار اپنانا",
        "content" : "",
        "reference" : "",
        "subHeading2" : "حدیث :",
        "content2" : "حضور نبی کریم <span class='fs-30'>ﷺ </span> نے ارشاد فرمایا </br> تم میں سے بہتر وہ ہے جو اپنے گھروالوں کے لیے بہتر ہو۔",
        "reference2" : "(سنن ترمذی : ۳۸۹۵)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : ""
    },
    {
        "id" : 11,
        "subHeading" : "۱۱۔ والدین کے ساتھ اچھا سلوک",
        "content" : "اسلام میں اپنے والدین کے ساتھ اچھا سلوک کرنا لازمی ہے۔",
        "reference" : "",
        "subHeading2" : "قرآن :",
        "content2" : "اور ہم نے انسان کو اس کے ماں باپ کے بارے میں تاکید فرمائی۔",
        "reference2" : "کہ وہ ان کا فرمانبردار رہے اور ان کے ساتھ نیک سلوک کرے۔",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "(سورۃ لقمان: ۱۴)"
    },
    {
        "id" : 12,
        "subHeading" : "۱۲۔ بیٹیوں کو ذلت سے بچانا",
        "content" : "اسلام میں بیٹیوں کو ذلت اور شرمندگی سے بچا کر عزت دینا لازم ہے۔",
        "reference" : "",
        "subHeading2" : "قرآن :",
        "content2" : "<span class='urduFont fs-30'>وَإِذَا ٱلْمَوْءُۥدَةُ سُئِلَتْ ٨  بِأَىِّ ذَنۢبٍۢ قُتِلَتْ ٩</span>",
        "reference2" : "ترجمہ: اور جب زندہ دفن کی جانے والی سے پوچھا جائے، کس گناہ پر ماری گئی۔",
        "subHeading3" : "",
        "content3" : "یعنی اس لڑکی سے جو زندہ دفن کی گئی ہو، جیسا کہ عرب کا دستور تھا کہ دورِ جاہلیت میں لڑکیوں کو زندہ دفن کر دیتے تھے۔",
        "reference3" : ""
    },
    {
        "id" : 13,
        "subHeading" : "",
        "content" : `کیا فضیلتیں آئی ہیں قرآن اور حدیثِ پاک میں بیٹیوں کے تعلق سے۔
                            مگر افسوس! آج کے زمانے میں لوگ لڑکی کی پیدائش پر غمزدہ ہو جاتے ہیں۔
                            لڑکیوں کو لڑکوں جیسا درجہ، عزت اور حق نہیں دیتے۔
                            لوگ لڑکوں کو نسل کا چراغ سمجھتے ہیں مگر بیٹیاں تو نہ صرف دنیا میں ان کی خدمت کرتی ہیں والدین کے وصال کے بعد بھی ان کے جنت کا سبب بنتی ہیں۔ جب وہ بیٹی ہوتی ہے، اپنے والد کے لیے جنت کے دروازے کھول دیتی ہے۔
                            جب وہ بیوی بنتی ہے، شوہر کا آدھا(نصف) دین مکمل کر دیتی ہے۔
                            جب وہ ماں بنتی ہے، جنت اس کے قدموں میں ہوتی ہے۔ </br>
                            : تبھی تو کسی شاعر نے کیا خوب کہا ہے کہ  </br>
                             بیٹیاں سبکے مقدر میں کہا ہوتی ہیں "</br>
                           " گھر خدا کو جو پسند آئے وہاں ہوتی ہیں۔`,
        "reference" : "",
        "subHeading2" : "",
        "content2" : "",
        "reference2" : "",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : ""
    } 
  ],
  hindiLang : [
    {
        "id" : 0,
        "subHeading" : "लड़कियों और औरतों का हाल हुज़ूर नबी-ए-करीम <span class='fs-30'>ﷺ </span> के आने से पहले :",
        "content" : "हुज़ूर नबी-ए-करीम <span class='fs-30'>ﷺ </span> के आने से पहले दुनिया में औरतों और लड़कियों के साथ जो सुलूक होता था, वो निहायत ज़लील और इंसानियत के उसूलों के खिलाफ था। उन्हें न सिर्फ अपने हक़ों से महरूम रखा जाता था, बल्कि उन्हें एक बोझ समझा जाता था। अरब और दुनिया के विभिन्न हिस्सों में औरतों की हालत निहायत अफसोसनाक थी, और उनका मकाम मर्द के मुकाबले में बहुत नीचा था।", 
        "reference" : "",
        "subHeading2" : "अरब में औरतों और लड़कियों की हालत",
        "content2" : "जाहिलियत के दौर में अरब में लड़की की पैदाइश को शर्म का सबब समझा जाता था। लोग अपनी बेटियों को जिंदा दफन कर दिया करते थे, क्योंकि उनका मानना था कि बेटी सिर्फ बेइज्ज़ती का सबब बनेगी। औरतों के पास किसी किस्म के हक़ नहीं थे, और न ही कोई इज़्जत। अरब के अलावा, दुनिया के दूसरे हिस्सों में भी औरतों की हालत अलग नहीं थी। हिंदुस्तान में औरतों को मर्द की मिल्कियत समझा जाता था। 'सति' का रिवाज था जिसमें मर्द के इंतकाल के बाद उसकी बीवी को भी उसके साथ जिंदा जला दिया जाता था। तालीम और आज़ादी का कोई तसव्वुर नहीं था।",
        "reference2" : "",
        "subHeading3" : "हुज़ूर नबी-ए-करीम <span class='fs-30'>ﷺ </span> की तालीमात और औरतों के हक़ूक़",
        "content3" : "हुज़ूर नबी-ए-करीम <span class='fs-30'>ﷺ </span> के आने के बाद औरतों के लिए एक नए दौर का आग़ाज़ हुआ। इस्लाम ने औरत को इज़्जत, मकाम और हक़ूक़ दिए जो उसे पहले कभी नहीं मिले थे। लड़की की पैदाइश को रहमत क़रार दिया गया, और बेटी की परवरिश को सवाब और जन्नत का ज़रिया बनाया गया। क़ुरआन-ए-पाक ने औरतों के मकाम को बुलंद किया और इंसानी बराबरी का तसव्वुर दिया। शादी और तलाक़ के निज़ाम को इंसाफ़ पर आधारित बनाया गया। औरतों को माल में हिस्सा दिया गया। हुज़ूर नबी-ए-करीम <span class='fs-30'>ﷺ </span> ने अपने अमल और तालीमात के ज़रिए समाज में औरतों के मकाम को इज़्जत दी। मां, बहन, बीवी और बेटी के रूप में औरतों के हक़ूक़ और इज़्जत को तस्लीम किया गया।",
        "reference3" : ""
    },
    {
        "id" : 1,
        "subHeading" : "1. ज़माना-ए-जाहिलियत में बेटी का हाल",
        "content" : "ज़माना-ए-जाहिलियत में बेटियों को शर्म और ज़िल्लत का सबब समझा जाता था। क़ुरआन मजीद में इस रवैये की सख्त मज़म्मत की गई है:",
        "reference" : "",
        "subHeading2" : "क़ुरआन :",
        "content2" : "और जब इनमें से किसी को बेटी होने की ख़ुशखबरी दी जाती है तो दिनभर उसका मुँह सियाह (काला) रहता है और वो ग़ुस्सा खाता है, लोगों से (शर्म के मारे) छुपता फिरता है इस बशारत की बुराई के सबब, क्या उसे ज़िल्लत के साथ रखेगा या उसे मिट्टी में दबा देगा, क्या बहुत ही बुरा हुक्म लगाते हैं।",
        "reference2" : "(Surah An-Nahl: 58-59)",
        "subHeading3" : "",
        "content3" : "इस्लाम ने बेटी को जिंदा दफन करने की इस रिवायत को पूरी तरह खत्म किया।",
        "reference3" : ""
    },
    {
        "id" : 2,
        "subHeading" : "2. बेटी की पैदाइश को बरकत और रहमत क़रार देना",
        "content" : "इस्लाम ने बेटियों की पैदाइश को नफ़रत की जगह एक बरकत और रहमत क़रार दिया। जहालत के दौर में लोग बेटियों को ज़िंदा दफन कर देते थे, लेकिन इस्लाम ने इस जहालत को खत्म किया। इस्लाम ने बेटी की पैदाइश को न केवल बरकत समझा, बल्कि जन्नत का ज़रिया बना दिया।",
        "reference" : "",
        "subHeading2" : "हदीस :",
        "content2" : "हुज़ूर नबी-ए-करीम <span class='fs-30'>ﷺ </span> ने इरशाद फरमाया: </br> जिसने 2 लड़कियों की क़िफ़ालत की तो मैं और वह जन्नत में इस तरह दाख़िल होंगे। आप <span class='fs-30'>ﷺ </span> ने कैफियत बताने के लिए अपनी दोनों उंगलियों (शहादत और दरमियानी) से इशारा किया।",
        "reference2" : "(सुनन तिर्मिजी, हदीस नंबर 1914)",
        "subHeading3" : "क़ुरआन:",
        "content3" : "अल्लाह ही के लिए है आसमानों और ज़मीन की सल्तनत, पैदा करता है जो चाहे, जिसे चाहे बेटियां अता फरमाए और जिसे चाहे बेटे दे",
        "reference3" : "(सुरह अश-शूरा: 49)",
        "subHeading4" : "अल्लाह की रज़ा पर राज़ी रहना",
        "content4" : "अल्लाह की मर्जी और हिकमत के मुताबिक़ ही सब कुछ होता है। एक मोमिन के लिए यह ज़रूरी है कि वह समझे कि जो अल्लाह देता है, उसमें उसकी रहमत और बेहतरीन योजना छुपी होती है। अल्लाह हर चीज़ का मालिक है। बेटी हो या बेटा, दोनों का मिलना अल्लाह की तरफ़ से एक इनायत है, और यह इंसान के बस में नहीं है। इस्लाम ने बेटियों को इज़्जत और मक़ाम दिया है। हुज़ूर नबी-ए-करीम <span class='fs-30'>ﷺ </span> ने बेटियों की परवरिश करने और उनके साथ अच्छा सुलूक करने को जन्नत का ज़रिया क़रार दिया है। बेटियां किसी तरह से भी कम नहीं हैं, बल्कि एक बरकत और रहमत हैं। सिर्फ बेटों की तमन्ना करना और बेटियों को कम समझना इस्लाम की तालीम के खिलाफ़ है। जो कुछ अल्लाह देता है, हमें उस पर राज़ी रहना और शुक्र अदा करना चाहिए। इस्लाम का पैग़ाम है कि बेटियां और बेटे दोनों बराबर हैं। दोनों अल्लाह की नेमत हैं और दोनों की परवरिश मोहब्बत और तवज्जो के साथ होनी चाहिए। हमें अपनी चाहत और दुआओं को अल्लाह की रज़ा के मुताबिक़ रखना चाहिए। अगर अल्लाह बेटियां देता है तो यह उसकी रहमत है, और हमें उन (बेटियों) की तर्बियत मोहब्बत और दीन के मुताबिक़ करनी चाहिए। अल्लाह के हर फ़ैसले को क़ुबूल करना और उसका शुक्र अदा करना एक सच्चा मोमिन बनाता है।",
        "reference4" : ""
    },    
    {
        "id" : 3,
        "subHeading" : "३. बेटियों के साथ मोहब्बत और शफकत का सुलूक",
        "content" : "इस्लाम ने बेटियों के साथ मोहब्बत का सुलूक करने का हुक्म दिया।",
        "reference" : "",
        "subHeading2" : "",
        "content2" : "",
        "reference2" : "",
        "subHeading3" : "हदीस :",
        "content3" : "हुज़ूर नबी-ए-करीम ﷺ ने इरशाद फरमाया: </br> जिस शख्स के यहाँ बेटी की पैदाइश हो, वो इसे ज़िंदा दफन करे और न ही इसे हल्का समझे और न ही लड़के को इस पर तर्जीह दे तो अल्लाह तआला उसे जन्नत में दाखिला अता फरमाएगा।",
        "reference3" : "(मुस्नद अहमद, हदीस नं. 1957)"
    },
    {
        "id" : 4,
        "subHeading" : "४. बेटियों की तर्बियत का अहम किरदार",
        "content" : "इस्लाम में बेटियों की तालीम और तर्बियत को जन्नत का ज़रिया क़रार दिया गया है।",
        "reference" : "",
        "subHeading2" : "हदीस :",
        "content2" : "हुज़ूर नबी-ए-करीम ﷺ ने इरशाद फरमाया: </br> जिस शख्स ने ३ बेटियों की परवरिश की, उन्हें आदाब सिखाया, उनकी शादी की और उनके साथ एहसान का सुलूक किया, तो उसके लिए जन्नत है।",
        "reference2" : "(सुनन अबू दाऊद, हदीस नं. 5147)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : ""
    },
    {
        "id" : 5,
        "subHeading" : "५. बेटियां, जन्नत में ले जाने का ज़रिया",
        "content" : "",
        "reference" : "",
        "subHeading2" : "हदीस :",
        "content2" : "हुज़ूर नबी-ए-करीम ﷺ ने इरशाद फरमाया: </br> जिस शख्स की ३ बेटियां हों और वो उनकी मुश्किलात, तकलीफों और खुशियों पर सब्र और शुक्र करे, अल्लाह उन बच्चियों पर उसकी मेहरबानी के सबब उसे जन्नत में अपने फ़ज़ल से दाखिला अता फरमाएगा, किसी ने पूछा, 'या रसूल अल्लाह ﷺ अगर २ बेटियां हों तो?' आप ﷺ ने फरमाया, 'तब भी यही हुक्म है', किसी ने पूछा, 'या रसूल अल्लाह ﷺ अगर १ बेटी हो तो?' आप ﷺ ने फरमाया, 'तब भी यही हुक्म है।'",
        "reference2" : "(मुस्नद अहमद : 8406)",
        "subHeading3" : "",
        "content3" : "इस्लाम में बेटियों को रहमत क़रार दिया गया है। उनकी पैदाइश पर खुशी मनाना, उनकी तालीम और तर्बियत करना, उनके हुक़ूक़ का ख़्याल रखना, उनसे मोहब्बत करना, और उनके साथ हुस्न-ए-सुलूक करना एक मुसलमान की बुनियादी ज़िम्मेदारी है। वालिदैन के लिए बेटियों की अच्छी तर्बियत और उनकी ज़िम्मेदारियों को खुश असलूबी से निभाना जन्नत के हासिल का ज़रिया है।",
        "reference3" : ""
    },
    {
        "id" : 6,
        "subHeading" : "६. बेटियां, जहन्नम की आग से रुकावट",
        "content" : "",
        "reference" : "",
        "subHeading2" : "हदीस :",
        "content2" : "हुज़ूर नबी-ए-करीम ﷺ ने इरशाद फरमाया: </br> जिस शख्स की ३ या २ बेटियां या बहनें हों, वो उनके मामले में अल्लाह से डरे और उनके साथ अच्छा सुलूक करे यहाँ तक कि उनकी शादी हो जाए या वो निधन कर जाएं तो वो उसके लिए जहन्नम की आग से रुकावट बन जाएंगी।",
        "reference2" : "(मुस्नद अहमद : 24508)",
        "subHeading3" : "हदीस :",
        "content3" : "हुज़ूर नबी-ए-करीम ﷺ ने इरशाद फरमाया: </br> जिस के पास तीन लड़कियां हों, और वो उनके होने पर सब्र करे, और जो कुछ मयस्सर हो उसमें से उन्हें खिलाए, पिलाए और पहनाए, तो वो उस शख्स के लिए क़ियामत के दिन जहन्नम से रुकावट बन जाएंगी।",
        "reference3" : "(सुनन इब्न माजा, हदीस 3669)"
    },
    {
        "id" : 7,
        "subHeading" : "७. बेटियों को तकलीफ़ न देने की नसीहत",
        "content" : "इस्लाम ने बेटियों को तकलीफ़ पहुँचाने से सख्त मना किया है।",
        "reference" : "",
        "subHeading2" : "हदीस :",
        "content2" : "हुज़ूर नबी-ए-करीम ﷺ ने इरशाद फरमाया: </br> औरतों के साथ अच्छा सुलूक करो।",
        "reference2" : "(बेटियों को भी औरतों के ज़ुमरे में शामिल किया गया है, इसलिए उनके साथ शफ़क़त और एहराम का रवैया अपनाना ज़रूरी है।)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "(बुखारी शरीफ : 3331)"
    },
    {
        "id" : 8,
        "subHeading" : "८. बेटियों के लिए माली हक़ूक़",
        "content" : "",
        "reference" : "",
        "subHeading2" : "विरासत में हिस्सा :",
        "content2" : "बेटियों को विरासत में उनका हक़ दिया जाए।",
        "reference2" : "",
        "subHeading3" : "क़ुरआन :",
        "content3" : "लड़की का हिस्सा लड़के के हिस्से का आधा है।",
        "reference3" : "(सुरह अन-निसा: 11)"
    },
    {
        "id" : 9,
        "subHeading" : "९. तालीम और तदरीस",
        "content" : "इस्लाम में तालीम हासिल करना फर्ज और जरूरत है। क़ुरआन और हदीस दोनों में तालीम की अहमियत पर जोर दिया गया है।",
        "reference" : "",
        "subHeading2" : "हदीस :",
        "content2" : "<span class='urduFont fs-30'>طَلَبُ الْعِلْمِ فَرِيضَةٌ عَلَى كُلِّ مُسْلِمٍ</span>",
        "reference2" : "",
        "subHeading3" : "",
        "content3" : "इल्म हासिल करना हर मुसलमान पर फर्ज है।",
        "reference3" : "(सुनन इब्न माजा, हदीस 224)"
    },
    {
        "id" : 10,
        "subHeading" : "१०. अच्छा किरदार अपनाना",
        "content" : "",
        "reference" : "",
        "subHeading2" : "हदीस :",
        "content2" : "हुज़ूर नबी-ए-करीम ﷺ ने इरशाद फरमाया: </br> तुममें से बेहतर वो है जो अपने घरवालों के लिए बेहतर हो।",
        "reference2" : "(सुनन तिर्मिज़ी : 3895)",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : ""
    },
    {
        "id" : 11,
        "subHeading" : "११. वालिदैन के साथ अच्छा सुलूक",
        "content" : "इस्लाम में अपने वालिदैन के साथ अच्छा सुलूक करना लाज़मी है।",
        "reference" : "",
        "subHeading2" : "क़ुरआन :",
        "content2" : "और हमने इंसान को उसके माँ-बाप के बारे में ताकीद फरमाई।",
        "reference2" : "कि उनका फरमाबردار रहे और उनके साथ नेक सुलूक करे।",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : "(सुरह लुकमान: 14)"
    },
    {
        "id" : 12,
        "subHeading" : "१२. बेटियों को ज़िल्लत से बचाना",
        "content" : "इस्लाम में बेटियों को ज़िल्लत और शर्मिंदगी से बचा कर इज्जत देना लाज़िम है।",
        "reference" : "",
        "subHeading2" : "क़ुरआन :",
        "content2" : "<span class='urduFont fs-30'>وَإِذَا ٱلْمَوْءُۥدَةُ سُئِلَتْ ٨  بِأَىِّ ذَنۢبٍۢ قُتِلَتْ ٩</span>",
        "reference2" : "तर्जुमा: और जब ज़िंदा दफन की गई लड़की से पूछा जाएगा, किस गुनाह के लिए उसे मारा गया?",
        "subHeading3" : "",
        "content3" : "यह उस लड़की के बारे में है जो ज़माना-ए-जाहिलियत में ज़िंदा दफन की जाती थी। इस्लाम ने बेटियों को इस कड़ी शर्मिंदगी और ज़िल्लत से बचाने का हुक्म दिया है।",
        "reference3" : ""
    },
    {
        "id" : 13,
        "subHeading" : "",
        "content" : "क़ुरआन और हदीस-ए-पाक में बेटियों के तल्लुक से क्या फ़ज़ीलतें आईं हैं।</br> मगर अफसोस! आज के ज़माने में लोग लड़की की पैदाइश पर ग़मज़दा हो जाते हैं।</br> लड़कियों को लड़कों जैसा दर्जा, इज़्जत और हक नहीं देते।</br> लोग लड़कों को नस्ल का चिराग़ जानते हैं मगर बेटियाँ तो न सिर्फ़ दुनिया में उनकी ख़िदमत करती हैं, बल्कि वालिदैन के विसाल के बाद भी उनकी जन्नत का सबब बनती हैं।</br> जब वो बेटी होती है, अपने वालिद के लिए जन्नत के दरवाजे खोल देती है।</br> जब वो बीवी बनती है, पति का आधा (Half) दीन मुकम्मल कर देती है।</br> जब वो माँ बनती है, जन्नत उसके क़दमों में होती है।</br> तभी तो किसी शायर ने क्या खूबसूरत कहा है कि:</br> 'बेटियाँ सबके मुक़द्दर में कहाँ होती हैं, </br>घर खुदा को जो पसंद आए वहाँ होती हैं।'",
        "reference" : "",
        "subHeading2" : "",
        "content2" : "",
        "reference2" : "",
        "subHeading3" : "",
        "content3" : "",
        "reference3" : ""
    } 
  ]
}

export default data;